<template>
  <el-container class="fullheight2">
    <el-container>
      <el-main>
        <eco-table
          ref="schedulerTable"
          @load="loadData"
          :data="data"
          :pageResult="pageResult"
          :selection="true"
          quick-search-props="name,formName,formKey,F_def_key"
          :show-export="false"
        >
          <template v-slot:toolbar>
            <el-button
              size="small"
              @click="schedulerTableAdd"
              type="primary"
              >添加</el-button
            >
          </template>
          <template>
            <eco-table-column
              type="index"
              width="50"
              align="center"
              label="序号"
            />
            <eco-table-column prop="formName" label="表单名称" />
            <eco-table-column prop="formKey" label="表单formKey" />
            <eco-table-column prop="url" label="PC路由（填写name）" />
            <eco-table-column prop="parentPath" label="PC路由地址(取父级)" />
            <eco-table-column prop="dataKey" label="模型key" />
            <eco-table-column prop="name" label="流程名称" />
            <eco-table-column prop="F_def_key" label="流程defKey" />
            <eco-table-column prop="app_apply_pic_url" label="app发起图片" />
            <eco-table-column prop="app_apply_url" label="app发起地址" />
            <eco-table-column prop="app_approve_url" label="app审批地址" />
            <eco-table-column width="180" label="操作">
              <template v-slot="{ row }">
                <el-link type="primary" :underline="false" @click="handleCommand(row)"
                  >编辑</el-link
                >
                <el-link type="primary" :underline="false" @click="handleCommandDel(row)" class="marginLeft16"
                  >删除</el-link
                >
              </template>
            </eco-table-column>
          </template>
        </eco-table>

        <!-- 添加-->
        <el-dialog
          width="70%"
          :title="schedulerAddTitle"
          :visible="dialogAddVisible"
          :before-close="handleAddClose"
        >
          <el-form
            ref="formAdd"
            :model="schedulerAdd"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item
              label="表单名称"
              prop="formName"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="schedulerAdd.formName"></eco-input>
            </el-form-item>
            <el-form-item
              label="表单formKey"
              prop="formKey"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="schedulerAdd.formKey"></eco-input>
            </el-form-item>
            <el-form-item
              label="PC路由（填写name）"
              prop="url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="schedulerAdd.url"
                placeholder="PC路由（填写name）"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="PC路由地址(取父级)"
              prop="parentPath"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="schedulerAdd.parentPath"
                placeholder="PC路由（填写name）"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="模型key"
              prop="dataKey"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="schedulerAdd.dataKey"
                placeholder="模型key"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="流程名称"
              prop="name"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="schedulerAdd.name"></eco-input>
            </el-form-item>
            <el-form-item
              label="流程key"
              prop="def_key"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="schedulerAdd.def_key"></eco-input>
            </el-form-item>
            <el-form-item
              label="app发起图片"
              prop="app_apply_pic_url"
              label-width="120px"
              class="scheduler-input-width is-required"
            >
              <eco-input
                v-model="schedulerAdd.app_apply_pic_url"
                placeholder="请输入app发起图片(相对地址)"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="app发起地址"
              prop="app_apply_url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="schedulerAdd.app_apply_url"
                placeholder="请输入app发起地址"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="app审批地址"
              prop="app_approve_url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="schedulerAdd.app_approve_url"
                placeholder="请输入app审批地址"
              ></eco-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="submitAdd('formAdd')"
              type="primary"
              :loading="tempAddLoading"
              >确定</el-button
            >
            <el-button @click="handleAddClose">取消</el-button>
          </div>
        </el-dialog>
        <!--   编辑-->
        <el-dialog
          width="70%"
          :title="schedulerTitle"
          :visible="dialogVisible"
          :before-close="handleClose"
        >
          <el-form
            ref="form"
            :model="scheduler"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item
              label="表单名称"
              prop="formName"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="scheduler.formName"></eco-input>
            </el-form-item>
            <el-form-item
              label="表单formKey"
              prop="formKey"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="scheduler.formKey"></eco-input>
            </el-form-item>
            <el-form-item
              label="PC路由（填写name）"
              prop="url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="scheduler.url"
                placeholder="PC路由（填写name）"
              ></eco-input>
            </el-form-item>
            <el-form-item
                label="PC路由地址(取父级)"
                prop="parentPath"
                label-width="120px"
                class="scheduler-input-width"
            >
              <eco-input
                  v-model="scheduler.parentPath"
                  placeholder="PC路由（填写name）"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="模型key"
              prop="dataKey"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="scheduler.dataKey"
                placeholder="模型key"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="流程名称"
              prop="name"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="scheduler.name"></eco-input>
            </el-form-item>
            <el-form-item
              label="流程key"
              prop="def_key"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input v-model="scheduler.def_key"></eco-input>
            </el-form-item>
            <el-form-item
              label="app发起图片"
              prop="app_apply_pic_url"
              label-width="120px"
              class="scheduler-input-width is-required"
            >
              <eco-input
                v-model="scheduler.app_apply_pic_url"
                placeholder="请输入app发起图片(相对地址)"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="app发起地址"
              prop="app_apply_url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="scheduler.app_apply_url"
                placeholder="请输入app发起地址"
              ></eco-input>
            </el-form-item>
            <el-form-item
              label="app审批地址"
              prop="app_approve_url"
              label-width="120px"
              class="scheduler-input-width"
            >
              <eco-input
                v-model="scheduler.app_approve_url"
                placeholder="请输入app审批地址"
              ></eco-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="submit('form')"
              type="primary"
              :loading="tempAddLoading"
              >确定</el-button
            >
            <el-button @click="handleClose">取消</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import sys from "@/api/portal";
export default {
  data() {
    return {
      schedulerDisabled: false,
      schedulerTitle: "编辑",
      schedulerAddTitle: "添加",
      loadDataUrl: "",
      dialogVisible: false,
      dialogAddVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      isSubmit: true,
      scheduler: {},
      schedulerAdd: {},
      ent: {},
      isStandby: true,
      isExistUrl: "",
      isExistType: "",
      validClassUrl: "",
      parameterJson: [],
      paraTypes: [
        { key: "int", value: "int" },
        { key: "long", value: "long" },
        { key: "float", value: "float" },
        { key: "string", value: "string" },
        { key: "boolean", value: "boolean" }
      ],
      isEdit: false,
      saveschedulerUrl: "",
      executeJobUrl: "",
      tempAddLoading: false,
      rules: {
        formName: [
          { required: true, message: "请输入表单名称", trigger: "blur" }
        ],
        formKey: [{ required: true, message: "请输入表单key", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.$validator = this.$root.$validator;
  },
  updated() {
    if (this.isEdit) {
      this.saveschedulerUrl =
        window.context.portal +
        "/job/scheduler/v1/saveJob?jobName=" +
        this.scheduler.jobName;
    } else {
      this.saveschedulerUrl =
        window.context.portal + "/job/scheduler/v1/addJob";
    }
  },
  methods: {
    // 添加
    schedulerTableAdd() {
      this.dialogAddVisible = true;
    },
    submitAdd(formName) {
      this.$refs[formName].validate(valid => {
        this.tempAddLoading = true;
        if (valid) {
          let params = Object.assign({}, this.schedulerAdd);
          sys
            .getUpdateFlowRouterAdd(params)
            .then(() => {
              this.tempAddLoading = false;
              this.handleAddClose();
            })
            .catch(() => {
              this.tempAddLoading = false;
            });
        } else {
          this.tempAddLoading = false;
          return false;
        }
      });
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        this.tempAddLoading = true;
        if (valid) {
          let params = Object.assign({}, this.scheduler);
          sys
            .getUpdateFlowRouter(params)
            .then(() => {
              this.tempAddLoading = false;
              this.handleClose();
            })
            .catch(() => {
              this.tempAddLoading = false;
            });
        } else {
          this.tempAddLoading = false;
          return false;
        }
      });
    },
    //验证任务名和类名
    isExist(type) {
      this.isExistType = type;
      var name = this.scheduler.className;
      if (type == "jobName") {
        name = this.scheduler.jobName;
      }
      this.isExistUrl =
        "/job/scheduler/v1/isExist?type=" + type + "&name=" + name;
    },
    //切换定时计划状态
    changeStart() {
      sys.changeStart(this.isStandby).then(
        data => {
          if (data.state) {
            this.$message.success(data.message);
          } else {
            this.$message.error(data.message || "操作失败");
          }
        },
        error => {
          this.$message.error(error || "操作失败");
        }
      );
    },
    deleteEntRows(rows) {
      this.parameterJson.remove(rows);
    },
    addEntRows() {
      let temp = {
        name: "",
        type: "",
        value: "",
        relation: ""
      };
      this.parameterJson.push(temp);
    },
    beforeSaveData() {
      if (!this.scheduler.className) {
        this.$message.warning("任务类不能为空");
        this.isSubmit = false;
        return;
      }
      this.scheduler.parameterJson = JSON.stringify(this.parameterJson);
      this.isSubmit = true;
    },
    afterGetStand(data) {
      this.isStandby = data;
    },
    afterValidClass(rep) {
      if (rep && rep.state) {
        this.$message.success(rep.message);
      }
    },
    afterExecuteJob(rep) {
      if (rep && rep.state) {
        this.$message.success(rep.message);
      } else {
        this.$message.error(rep.message || "执行失败");
      }
      this.executeJobUrl = "";
    },
    afterIsExist(data) {
      if (data) {
        var msg =
          this.isExistType == "jobName"
            ? "任务名称已经存在，请重新填写！"
            : "任务列表中已添加该任务类记录，不能多次添加同一任务类！";
        this.$message.error(msg);
        if (this.isExistType == "jobName") {
          this.scheduler.jobName = "";
        } else {
          this.scheduler.className = "";
        }
      }
      this.isExistType = "";
      this.isExistUrl = "";
    },
    afterLoadData(data) {
      // 编辑定时计划
      if (this.dialogVisible) {
        this.scheduler = data;
        if (this.scheduler.parameterJson) {
          this.parameterJson = JSON.parse(this.scheduler.parameterJson);
        } else {
          this.parameterJson = [];
        }
        setTimeout(() => this.$validator.validateAll("editschedulerForm"));
      }
    },
    handleAddClose() {
      this.dialogAddVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    loadData(param, cb) {
      sys
        .getFlowRouterList(param)
        .then(response => {
          this.data = response.rows.map(item => {
            item['F_def_key'] = item.def_key;
            return item
          });
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          };
        })
        .finally(() => cb());
    },
    // 编辑
    handleCommand(row) {
      this.dialogVisible = true;
      this.scheduler = row;
    },
    // 删除
    handleCommandDel(row) {
      let that = this;
      that
        .$confirm("是否删除？", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "保存",
          cancelButtonText: "取消"
        })
        .then(() => {
          let params = {
            id: row.id
          };
          sys.getUpdateFlowRouterDel(params).then(() => {
            that.$message({
              type: "success",
              message: "删除成功"
            });
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.fullheight2 {
  padding-top: 16px;
  height: calc(100% - 50px);
}
.el-main {
  padding: 0px;
}
.obj-atter {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-left: 10px;
}
.obj-atter-panel {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f4f4f5;
  height: 50px;
  line-height: 50px;
  padding: 0px 15px;
}
.scheduler-input-width .inputs {
  width: 100%;
}
</style>
